<template lang="pug">
	.v-info-product.info-product(v-if="banner" :class="{'info-product-banner': isProduct}")
		.info-banner__container.container
			.info-banner__wrap
				.info-banner__left
					.info-banner__info-wrap
						template(v-if="!isLg")
							template(v-for="(item, index) in banner.items" :key="index")
								img.info-banner__image(:src="item.image" alt="" :class="{'info-banner__image--visible': index === activeIndex}")
						.info-banner__info
							.info-banner__supertitle(v-if="banner.supertitle")
								v-svg-icon.info-banner__supertitle-icon(:icon="banner.icon")
								.info-banner__supertitle-text {{banner.supertitle}}
							h2.info-banner__title.flc(v-if="banner.title" v-html="banner.title")
							.info-banner__subtitle.flc(v-if="banner.subtitle" v-html="banner.subtitle")
						ul.info-banner__list(v-if="!isLg && banner.items && banner.items.length")
							template(v-for="(item, index) in banner.items" :key="index")
								li.info-banner__list-item.flc(:class="{'active': index === activeIndex}" v-html="item.titleLeft")
				.info-banner__right
					.info-banner__items(v-if="banner.items" :class="`info-banner__items--overlay-color-${banner.items[activeIndex].color}`")
						.info-banner__item.flc(
							v-for="(item, index) in banner.items"
							:key="index" :ref="'item' + index"
							:data-hash="item.id"
							:id="item.id"
							:class="[item.colorOption ? `info-banner__item--${item.colorOption}` : '']"
						)
							img.info-banner__image(v-if="isLg" :src="item.imageMob" alt="" :class="{'info-banner__image--visible': index === activeIndex}")
							.info-banner__item-wrap
								.info-banner__item-header-wrap
									//h3.info-banner__item-title(v-if="item.title" v-html="item.title")
									//.info-banner__item-icon-wrap
									//	v-svg-icon.info-banner__item-icon(:icon="item.icon")
									.info-banner__item-title-wrap
										h2.bg-banner__title.flc(v-if="item.title" v-html="item.title")
										span.bg-banner__subtitle.flc(v-if="item.subtitle" v-html="item.subtitle")
										.info-banner__item-icon-wrap(v-if="item.icon")
											v-svg-icon.info-banner__item-icon(:icon="item.icon")

									.info-banner__item-text(v-if="item.text" v-html="item.text")
									.info-banner__cards(v-if="item.cardList && !isRuCheese ")
										.info-banner__card(
											v-for="(item, i) in item.cardList"
											:key="i"
											@click="clickToBannerItem(i === 0 ? {link: '3'} : {link: '#3'} , i)"
										)
											img.info-banner__card-background(
												v-if="item.image && item.image.src"
												:src="item.image.src"
												alt="item.image.alt"
											)
											.info-banner__item-icon-wrap(v-if="item.icon" :class="`info-banner__item-icon-wrap--${item.icon.color}`")
												v-svg-icon.info-banner__item-icon(:icon="item.icon.name")
											.info-banner__card-title(v-if="item.title" v-html="item.title" )
											.info-banner__card-text(v-if="item.text" v-html="item.text" )




								.info-banner__content
									h3.info-banner__item-title(v-if="item.contentTitle" v-html="item.contentTitle" :id="index === 1 ? '3': null")
									.info-banner__item-content--text.text-guide(v-if="item.textContent" v-html="item.textContent")

									v-accordion.info-banner__accordion(v-if="item.accordion" :items="item.accordion" :id="index === 1 ? '4' : null")
									v-banner-grid.info-banner__content-grid(v-if="item.gridList" :items="item.gridList")

									.bg-banner__list.flc(v-if="item.list")
										h3.info-banner__item-title(v-if="item.listTitle" v-html="item.listTitle")

										.bg-banner__list-item(v-for="(item, index) in item.list" :key="index" )
											.bg-banner__list-item_title(v-if="item.title" v-html="item.title" )
											.bg-banner__list-item_text(v-if="item.text") {{item.text}}

									.info-banner__item-content.text-guide(v-if="item.content" v-html="item.content")

									.info-banner__cards(v-if="item.cardList && isRuCheese")
										.info-banner__card(
											v-for="(item, i) in item.cardList"
											:key="i"
											@click="clickToBannerItem(i === 0 ? {link: '3'} : {link: '#3'} , i)"
										)
											img.info-banner__card-background(
												v-if="item.image && item.image.src"
												:src="item.image.src"
												alt="item.image.alt"
											)
											.info-banner__item-icon-wrap(v-if="item.icon" :class="`info-banner__item-icon-wrap--${item.icon.color}`")
												v-svg-icon.info-banner__item-icon(:icon="item.icon.name")
											.info-banner__card-title(v-if="item.title" v-html="item.title" )
											.info-banner__card-text(v-if="item.text" v-html="item.text" )

									.info-banner__item-action(v-if="item.link" )
										a.info-banner__item-btn.btn.btn--has-right-icon.btn--primary.btn--alt-hover(v-if="item.link" :href="item.link.link")
											.btn__text {{item.link.text}}
											.btn__icon-wrap
												v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
												v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")

							.bg-banner__right-bottom-bonus(v-if="item.bonus" :class="[`bg-banner__right-bottom-bonus--${item.bonus.bgColor}`, item.bonus.type || ``]")
								v-svg-icon.bg-banner__right-bottom-bonus_icon(v-if="item.bonus.icon" :icon="item.bonus.icon" :class="`bg-banner__right-bottom-bonus_icon--${item.bonus.iconBgColor}`")
								.bg-banner__right-bottom-bonus_text(v-if="item.bonus.text" ) {{item.bonus.text}}


					.bg-banner__right-bottom-bonus(v-if="banner.bonus" :class="`bg-banner__right-bottom-bonus--${banner.bonus.bgColor}`")
						v-svg-icon.bg-banner__right-bottom-bonus_icon(v-if="banner.bonus.icon" :icon="banner.bonus.icon" :class="`bg-banner__right-bottom-bonus_icon--${banner.bonus.iconBgColor}`")
						.bg-banner__right-bottom-bonus_text(v-if="banner.bonus.text" ) {{banner.bonus.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import VSvgIcon from "./helpers/v-svg-icon.vue";
import VAccordion from "../components/v-accordion.vue";
import VGridBanner from "./v-grid-banner.vue";
import VBannerGrid from "./v-banner-grid.vue";

export default {
	components: {VBannerGrid, VGridBanner, VSvgIcon, VAccordion},
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		isProduct: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			banner: null,
			activeIndex: 0,
			activeImage: this.banner?.items[0].image,
			itemHeaderHeight: 16,
			isRuCheese: false,
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				document.body.classList.remove('state--page-header-blackout');
				this.banner.items.forEach((item, index) => {
					let $currentItem = this.$refs['item' + index];
					if ($currentItem) {
						if (this.$el?.offsetTop + $currentItem[0].offsetTop - window.scrollY - window.innerHeight + (window.innerHeight / 3) < 0) {
							this.activeIndex = index;
						}
					}
				});
			}

			this.isRuCheese = document.querySelector('.region-ru') && window.location.pathname.includes('cheese');
		},

		clickToBannerItem(item, index) {
			if (!window.location.pathname.includes('/vet')) return;
			const targetId = item.tab_id || item.link || `${index+2}`;

			if (targetId) {
				controller.goToLink(targetId);
			}
		},

		dataSet(data) {
			this.banner = data;
			this.handleScroll();

			// TODO
			const route = window.location;
			const hostname = route.hostname;
			const iconsForVetPage = ['vet-5', 'vet-6'];
			const iconsForCheesePage = ['cheese-8', 'cheese-9'];

			if (route.pathname.includes('/vet')) {
				this.banner.items[1].cardList.map((item, index) => {
					item.icon = {
						name: iconsForVetPage[index],
						color: 'white'
					};
				});
			}

			if (route.pathname.includes('/cheese') && !hostname.startsWith('ru.')) {

				this.banner.items[2].cardList.map((item, index) => {
					item.icon = {
						name: iconsForCheesePage[index],
						color: 'white'
					};
				});
			}

			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
